import React from 'react';

const FilterWrapper = ({ className = '', children }) => (
  <div className={`wrapper-header ${className}`}>
    <div className="container-fluid">
      <div className="row align-items-end">{children}</div>
    </div>
  </div>
);

export default FilterWrapper;



// WEBPACK FOOTER //
// ./foody/src/components/Common/FilterWrapper.jsx